import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Article from 'src/smoothr-web-app-core/models/Article';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import OptionGroup from 'src/smoothr-web-app-core/models/OptionGroup';
import Order from 'src/smoothr-web-app-core/models/Order';
import { OrderUtils } from 'src/smoothr-web-app-core/utils/order-utils';
import { defaultsToArticleOption, numberD, numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';
import { RecomendationArticleModalComponent } from '../recomendation-article-modal/recomendation-article-modal.component';
import { AllergensInfoModalComponent } from '../allergens-info-modal/allergens-info-modal.component';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { DisplayMode } from '../../../smoothr-web-app-core/enums/DisplayMode';

@Component({
	selector: 'app-choose-size-of-product',
	templateUrl: './choose-size-of-product.component.html',
	styleUrls: ['./choose-size-of-product.component.scss'],
})
export class ChooseSizeOfProductComponent extends RepositoryDirective {
	public articleGroup: ArticleGroup;
	public optionGroups: OptionGroup[];
	public order: Order;
	public listOfArticleOptions: ArticleOption[] = [];
	numberToCurrency = numberToCurrency;
	OrderUtils = OrderUtils;

	constructor(private modalCtrl: ModalController, protected repository: RepositoryService, private analytics: AnalyticsService) {
		super(repository);
	}

	sizeOption(optionGroup: OptionGroup) {
		return !optionGroup.tags.find(tag => tag.identifier === 'recircle_bowls');
	}

	static async show(
		modalCtrl: ModalController,
		articleGroup: ArticleGroup,
		optionGroups: OptionGroup[],
		order: Order
	): Promise<{ value: ArticleOption[]; isCheckout: boolean }> {
		const modal = await modalCtrl.create({
			cssClass: 'choose-size-modal',
			component: ChooseSizeOfProductComponent,
			componentProps: {
				articleGroup,
				optionGroups,
				order,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();

		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	addOption(event: ArticleOption, optionGroup: OptionGroup) {
		if (this.listOfArticleOptions.find(it => it.article._id === event.article._id)) {
			this.listOfArticleOptions = this.listOfArticleOptions.filter(it => it.article._id !== event.article._id);
		} else {
			if (optionGroup.limit === 1) {
				const findArticleOption = this.listOfArticleOptions.find(it => it.group === optionGroup._id);
				if (!findArticleOption) {
					this.listOfArticleOptions.push(event);
				} else {
					this.listOfArticleOptions = this.listOfArticleOptions.filter(it => it.article._id !== findArticleOption.article._id);
					this.listOfArticleOptions.push(event);
				}
			} else {
				this.listOfArticleOptions.push(event);
			}
		}
	}

	totalPrice() {
		if (this.order) {
			const price = this.listOfArticleOptions.map(it => numberD(it.article.price)).reduce((a, b) => a + b, 0);
			// return numberToCurrency(OrderUtils.orderTotalPrice(this.order, true, true, null) + price, this.order.currency);
			return numberToCurrency(price, this.order.currency);
		}
		return '';
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}

	addToBasket() {
		this.modalCtrl.dismiss({ value: this.listOfArticleOptions, isCheckout: false });
	}

	async addToBasketAndCheckout() {
		//todo: fix code duplication

		if (this.listOfArticleOptions.length) {
			const mainRecommendations = this.articleGroup.article.mainRecommendations;

			if (mainRecommendations.length > 0) {
				let categoryArticles = [].concat(...this.venue.articleCategories.map(it => it.articles)) as Article[];
				categoryArticles = categoryArticles.filter(article => article.visible && article.isActive);

				const categoryArticlesMap = new Map(categoryArticles.map(it => [it._id, it]));
				const recommendedArticles: Article[] = [];

				mainRecommendations.forEach(it => {
					if (categoryArticlesMap.has(it)) {
						recommendedArticles.push(categoryArticlesMap.get(it));
					}
				});
				let result;
				if (recommendedArticles.some(art => art.visible)) {
					result = await RecomendationArticleModalComponent.show(this.modalCtrl, recommendedArticles, this.order);
					if (result?.data && result?.data?.length > 0) {
						result.data.forEach(itemRecom => {
							const articleGroup = new ArticleGroup();
							articleGroup.article = itemRecom.article;
							articleGroup.groups.push(
								...defaultsToArticleOption(
									itemRecom.article,
									[],
									itemRecom.article.defaults,
									this.order?.type,
									this.order.preorder.type
								)
							);
							articleGroup.quantity = itemRecom.quantity;
							OrderUtils.addToOrder(this.order, articleGroup, this.analytics);
							this.repository.onOrderChange(this.order);
						});
					}
				}
			}
		}

		this.modalCtrl.dismiss({ value: this.listOfArticleOptions, isCheckout: true });
	}

	showNutrition(article: Article) {
		AllergensInfoModalComponent.show(this.modalCtrl, article);
	}

	protected readonly DisplayMode = DisplayMode;
}
